import { render, staticRenderFns } from "./JgpMenu.vue?vue&type=template&id=972cf57c&"
import script from "./JgpMenu.vue?vue&type=script&lang=js&"
export * from "./JgpMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports